import { render, staticRenderFns } from "./CaseCard.vue?vue&type=template&id=33731b46&scoped=true"
import script from "./CaseCard.vue?vue&type=script&lang=js"
export * from "./CaseCard.vue?vue&type=script&lang=js"
import style0 from "./CaseCard.vue?vue&type=style&index=0&id=33731b46&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33731b46",
  null
  
)

export default component.exports